import { Component } from '@angular/core';

@Component({
  selector: 'app-gift-card-list',
  templateUrl: './gift-card-list.component.html',
  styleUrls: ['./gift-card-list.component.scss'],
  standalone: false,
})
export class GiftCardListComponent {}
